import DexLeftComponent from '@/components/DexLeftComponent';
import { assetUrl } from '@/utils/asset-url';
import usePage from '@/hooks/use-page';
import { useNavigate } from '@/lib/router-dom';
import { Box } from '@dextech-ai/dex-design-system';

const Page = () => {

	const { goTo } =  useNavigate()

	usePage({ title: 'Reset Password' })

	const resetPasswordStyles = {
		backgroundImage: `url("${assetUrl("/sgtradex-cover-login.png")}")`
	}

	/*=================================================
		MultiDex
	/================================================*/

	return (
		<div className='layout-login'>
			<DexLeftComponent />
			<div className="layout-login__right">
				<div className="login-box">
					<div className="resetPassword-box__title">Reset Password</div>
                    <Box mt={6}>New password successfully set</Box>
					<Box mt={10}>
						<form data-testid="form" onSubmit={()=>(goTo('/login'))}>
                            <Box mt={10}>
                                <div>
                                    <button type="submit" className="button--rounded resetPassword-box__button" value="Submit">Go to Log In</button>
                                </div>
                            </Box>
						</form>
					</Box>
				</div>
			</div>
		</div>
	)
}
export default Page
